import axios from "./httpClient";

export function getWhatsAppConversations(skip = 0, limit = 20) {
  return axios.get("/whatsapp/conversations", { params: { skip, limit } });
}

export function getWhatsAppMessages(phoneNumber, before = null, limit = 50) {
  const params = { limit };
  if (before) {
    params.before = before;
  }
  return axios.get(`/whatsapp/conversations/${encodeURIComponent(phoneNumber)}/messages`, { params });
}

export function getWhatsAppApplicant(phoneNumber) {
  return axios.get(`/whatsapp/conversations/${encodeURIComponent(phoneNumber)}/applicant`);
}
